import dynamic from 'next/dynamic';
import { ComponentType, useEffect, useState } from 'react';
import { iconPlaceholder as roleIconPlaceholder } from './../ui/Icon/role/Placeholder';
import { iconPlaceholder as sportIconPlaceholder } from './../ui/Icon/sport/Placeholder';

type LazyIcon = ComponentType<any> | undefined;

// sportName needs to NOT include the icon prefix
export const useLazyLoadSportIcon = (sportName: string): LazyIcon => {
  const [SportIcon, setSportIcon] = useState<LazyIcon>();

  useEffect(() => {
    (async () => {
      const dynamicIcon = await dynamic(
        () =>
          import(`../ui/Icon/SportIcons`).then(
            mod =>
              mod[`icon${sportName.replace(' & ', 'And').replace(' ', '')}`]
          ),
        { ssr: false }
      );

      setSportIcon(dynamicIcon);
    })();
  }, [sportName]);

  return SportIcon ?? sportIconPlaceholder;
};

// Role type needs to be a value from ROLE_ICON_IDS
export const useLazyLoadRoleIcon = (iconName: string): LazyIcon => {
  const [RoleIcon, setRoleIcon] = useState<LazyIcon>();

  useEffect(() => {
    (async () => {
      const dynamicIcon = await dynamic(
        () => import(`../ui/Icon/RoleIcons`).then(mod => mod[iconName]),
        { ssr: false }
      );

      setRoleIcon(dynamicIcon);
    })();
  }, [iconName]);

  return RoleIcon ?? roleIconPlaceholder;
};
